

















export default {
  name: "TabBar"
}
